var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 8.2C5.52 -1.4 18.48 -1.4 22.8 8.2",
    stroke: "#071E0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 13.0008C11.5274 13.0008 11.0593 12.9077 10.6225 12.7267C10.1858 12.5458 9.7889 12.2807 9.45461 11.9464C9.12032 11.6121 8.85514 11.2152 8.67423 10.7784C8.49331 10.3417 8.40019 9.87354 8.40019 9.40078C8.40019 8.92802 8.49331 8.45989 8.67423 8.02312C8.85514 7.58635 9.12032 7.18949 9.45461 6.8552C9.7889 6.52091 10.1858 6.25573 10.6225 6.07481C11.0593 5.8939 11.5274 5.80078 12.0002 5.80078C12.955 5.80078 13.8706 6.18007 14.5458 6.8552C15.2209 7.53033 15.6002 8.446 15.6002 9.40078C15.6002 10.3556 15.2209 11.2712 14.5458 11.9464C13.8706 12.6215 12.955 13.0008 12.0002 13.0008Z",
    stroke: "#071E0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1a68cb70b5fde7cb1b620474314861c2.svg";
export { ForwardRef as ReactComponent };